/**
 * @see /client/containers/MyEGiftCards/index.js
 * @see /client/containers/OrderSummary/index.js
 */
import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { constants } from '../../devUtils';
import NoImage from '../../assets/images/no-image-320x200.jpg';

const StyledItem = styled.div`
  display: inline-block;
  width: 100%;
  img{
    float: left;
    border-radius:5px;
    margin-right:10px;
  }
  strong{
    font-weight:600;
    font-weight: 600;
    float: left;
    width: 100%;
    margin-top: 15px;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      float: left;
    };
  }
`;

const renderUI = (data) => {
  const { value: { image, name } = {}, original: { variation, variation: { image: vImage } = {} } = {} } = data;
  return (
    <div>
      {image && variation && Object.keys(variation).length ?
        <img style={{ width: 150, height: 80 }} src={vImage || image.image.url} alt="no_image" /> :
        <img style={{ width: 150, height: 80 }} src={NoImage} alt="no_image" />}
      <strong> {name}</strong>
    </div>
  );
};

function Item(props) {
  const { data, isRouteEnabled } = props;
  return (
    <StyledItem>
      {isRouteEnabled ? (
        <Link to={`${constants.LINK_GIFTCARD_DETAILS}/${data.value.slug}`} state={data.value.client_id}>
          { renderUI(data)}
        </Link>
      ) : (renderUI(data))}
    </StyledItem>
  );
}

Item.propTypes = {
  data: PropTypes.shape({}),
  isRouteEnabled: PropTypes.bool,
};
Item.defaultProps = {
  isRouteEnabled: false,
};
export default Item;



// WEBPACK FOOTER //
// client/containers/MyEGiftCards/item.js